import { LessonBase } from 'src/@types/modules/lessons/lessons.types'
import { Lesson } from 'src/components/Lesson/Lesson'
import { ReactNode } from 'react'
import { map } from 'lodash'

export type GetLessonComponentParamsBase<LessonType> = {
    onLessonClick?: (lesson: LessonType) => void;
    isSelected?: (lesson: LessonType) => boolean;
    isDisabled?: (lesson: LessonType) => boolean;
}

export type GetLessonsComponentsParams<LessonType> =
    GetLessonComponentParamsBase<LessonType>
    & { lessons: (LessonType & LessonBase)[] }

export type GetLessonComponentParams<LessonType> =
    GetLessonComponentParamsBase<LessonType>
    & { lesson: (LessonType & LessonBase) }

export const getLessonComponents =
    <LessonType extends LessonBase, >
    (params: GetLessonsComponentsParams<LessonType>): ReactNode[] => {
        const lessonsMapper =
            (lesson: LessonType): ReactNode =>
                getLessonComponent<LessonType>({
                    lesson: lesson,
                    onLessonClick: params.onLessonClick,
                    isSelected: params.isSelected,
                    isDisabled: params.isDisabled,
                })
        
        return map(params.lessons, lessonsMapper)
    }

export const getLessonComponent =
    <LessonType, >
    (params: GetLessonComponentParams<LessonType>): ReactNode => {
        const { lesson, onLessonClick, isSelected, isDisabled } = params
        
        const onClick: VoidFunction =
            (): void => {
                if (onLessonClick) {
                    onLessonClick(lesson)
                }
            }
        
        return (
            <Lesson
                key={lesson.id}
                disabled={isDisabled ? isDisabled(lesson) : undefined}
                active={isSelected ? isSelected(lesson) : undefined}
                onClick={onClick}
            >
                {lesson.index}
            </Lesson>
        )
    }